import { For, Show, createSignal, onMount } from "solid-js";
import { actionLabel, formatDate, type AdminApi, type AuditEntry, type Paged } from "./api";

export function AuditView(props: { api: AdminApi; guard: <T>(work: () => Promise<T>) => Promise<T> }) {
  const [data, setData] = createSignal<Paged<AuditEntry>>({ items: [], total: 0, page: 1, limit: 50 });
  const [loading, setLoading] = createSignal(true);
  const [error, setError] = createSignal("");

  const load = async (page = 1) => {
    setLoading(true);
    setError("");
    try {
      setData(await props.guard(() => props.api.auditLog(page)));
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Laden fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };
  onMount(() => void load());

  const pages = () => Math.max(1, Math.ceil(data().total / data().limit));

  return (
    <section>
      <h2>Protokoll</h2>
      <Show when={error()}><p class="adm-error" role="alert">{error()}</p></Show>
      <div class="adm-card">
        <div class="adm-table-wrap">
          <table class="adm-table">
            <thead><tr><th>Zeit</th><th>Admin</th><th>Aktion</th><th>Ziel</th><th>Grund</th></tr></thead>
            <tbody>
              <For each={data().items}>
                {(entry) => (
                  <tr>
                    <td>{formatDate(entry.createdAt)}</td>
                    <td>{entry.admin ?? "–"}</td>
                    <td>{actionLabel(entry.action)}</td>
                    <td>{entry.targetType ? `${entry.targetType} ${entry.targetId ?? ""}`.trim() : "–"}</td>
                    <td>{entry.reason ?? "–"}</td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </div>
        <Show when={!loading() && data().items.length === 0}><p class="adm-empty">Noch keine Einträge.</p></Show>
        <div class="adm-pager">
          <button class="adm-btn ghost small" type="button" disabled={data().page <= 1 || loading()} onClick={() => void load(data().page - 1)}>Zurück</button>
          <span>Seite {data().page} von {pages()} · {data().total} Einträge</span>
          <button class="adm-btn ghost small" type="button" disabled={data().page >= pages() || loading()} onClick={() => void load(data().page + 1)}>Weiter</button>
        </div>
      </div>
    </section>
  );
}
